import axios from "axios";
import {joinUrl} from "../Utilities/UriUtilities";
import {acceptHeader, executeWithErrorResponseHandling} from "./ApiUtilities";
import {isRequestError} from "../Model/RequestError";
import {COUNTER_API_CALLS} from "../Service/CounterMetricsProvider";
import {Reseller} from "../Types/Reseller";

/**
 * Function will determine the current maintenance state.
 */
export const fetchMaintenanceState = async (
    domain: string,
    reseller: Reseller
): Promise<boolean> => {
    const formattedReseller = reseller.charAt(0).toUpperCase() + reseller.slice(1)
    const endpoint = joinUrl(domain, `/public/${formattedReseller}/maintenance`)
    const headers = acceptHeader()

    const response =
        await executeWithErrorResponseHandling<any>(() => axios.get(endpoint, {headers: headers}))

    if (isRequestError(response)) {
        COUNTER_API_CALLS.emit({severityNumber: 9, severityText: "INFO", body: "", attributes: {"api": "/maintenance", "status": "error"}})
        return Promise.resolve(false)
    } else {
        COUNTER_API_CALLS.emit({severityNumber: 9, severityText: "INFO", body: "", attributes: {"api": "/maintenance", "status": "success"}})
        return Promise.resolve(response.data["maintenance"])
    }
}
